export default "__VITE_ASSET__DBIKHUrV__"